@if (phaseCounts$ | async; as phaseCounts) {
  <ul class="stepper">
    @for (val of phaseCounts | keyvalue: noopSort; track trackByFn($index, val)) {
      <li
        class="stepper-stage"
        data-test-id="opportunity-top-bar-connect-phase-tab"
        [class]="{ 'stepper-stage-focused': activePhase === val.key }"
        (click)="viewPhase(toPhase(val.key))"
      >
        <span class="stepper-stage-count"> {{ val.value }} </span>
        <span class="stepper-stage-title" [attr.data-test-id]="`opportunity-phase-${val.key}`">
          {{ toPhase(val.key) | phaseName }}
        </span>
        <span
          [class.stepper-directional-arrow]="!$last"
          [class.stepper-directional-arrow-focused]="activePhase === val.key"
        >
        </span>
      </li>
    }
  </ul>
}
